<div id="segmentType" class="container mx-auto mb-16" data-cy="segment-type">
  <div class="form mt-20 md:mt-40">
    <ife-title [title]="'modules.evcSegment.title' | translate" data-cy="b2c-sme-title"></ife-title>

    <div class="flex flex-wrap md:mt-8 justify-center">
      <ife-checkbox
        id="b2c"
        data-cy="b2c"
        class="w-full mb-8 md:mr-16 sm:w-auto"
        value="b2c"
        [image]="'./assets/evc/img/b2c.svg'"
        [caption]="'modules.evcSegment.options.b2c' | translate"
        (click)="goTo('b2c')"
      >
      </ife-checkbox>
      <ife-checkbox
        id="sme"
        data-cy="sme"
        class="w-full mb-8 sm:w-auto"
        value="sme"
        [image]="'./assets/evc/img/sme.svg'"
        [caption]="'modules.evcSegment.options.sme' | translate"
        (click)="goTo('sme')"
      >
      </ife-checkbox>
    </div>
  </div>
</div>
